/**
 * Auth utility functions
 */
import { jwtDecode } from 'jwt-decode'

// The check runs against the browser clock, which drifts, so it needs an
// explicit tolerance. The tolerance is deliberately optimistic: a token whose
// nominal expiry passed less than the leeway ago still counts as valid, so a
// clock running fast does not log the customer out early. The price is that
// one request in that window can still earn a 401, which the refresh
// machinery handles. The backend stays the authority (SEZ-5044-R04).
const CLOCK_SKEW_LEEWAY_SECONDS = 30

/**
 * Check if token is expired. An empty token, an undecodable token and a token
 * without an `exp` claim all count as expired (SEZ-5044-R04).
 */
export function isTokenExpired(token) {
  if (!token) return true

  try {
    const { exp } = jwtDecode(token)
    if (!exp) return true
    return Date.now() >= (exp + CLOCK_SKEW_LEEWAY_SECONDS) * 1000
  } catch {
    return true
  }
}
